module.exports = __webpack_public_path__ + "static/img/img_reward_info.c2381f2b.png";